module.exports = __webpack_public_path__ + "media/images/banner9 (2)-28181f836c3e9175fb383b6e77567841.jpg";